import Fire from "./fire";

const SKIN_PROFILE_COLLECTION = "skin_profiles";

export interface RawSkinProfile {
  id: string;
  storageDir: string;
  url: string;
  dateMsec: number;
  feeling: string;
  sleep: string;
  skinType: string;
  skinTime: string;
  note: string;
  phone: string;
}

export interface RawSkinProfileToAdd {
  storageDir: string;
  url: string;
  dateMsec: number;
  feeling: string;
  sleep: string;
  skinType: string;
  skinTime: string;
  note: string;
  phone: string;
}

export default class SkinProfileModel {
  private static getDbRef() {
    const firestore = Fire.getFireStoreDb();
    return firestore.collection(SKIN_PROFILE_COLLECTION);
  }

  public static async fetchSkinProfilesByPhone(
    phone: string
  ): Promise<RawSkinProfile[]> {
    const db = this.getDbRef();
    const querySnapshot = await db
      .where("phone", "==", phone)
      .orderBy("dateMsec")
      .get();

    if (querySnapshot.docs.length === 0) {
      return [];
    }

    const skinProfiles: RawSkinProfile[] = [];

    querySnapshot.docs.forEach((doc) => {
      const skinProfile: RawSkinProfile = {
        id: doc.id,
        ...doc.data()
      } as RawSkinProfile;
      skinProfiles.push(skinProfile);
    });

    return skinProfiles;
  }

  public static deleteSkinProfile(skinProfileId: string) {
    const db = this.getDbRef();
    return db.doc(skinProfileId).delete();
  }

  public static addSkinProfile(skinProfile: RawSkinProfileToAdd) {
    const db = this.getDbRef();
    return db.add(skinProfile);
  }
}
